import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import "./Dashbord.css";
import { api, fetchData } from "../helper/api.interceptor";
import AddOpeningModal from "./AddOpeningModal";
import EditOpeningModal from "./EditOpeningModal"; // Added import



export const handleDeleteItem = async (url, id, setData) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This action cannot be undone!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (result.isConfirmed) {
    try {
      const res = await fetchData.delete(`${url}/${id}`);

      if (res?.success) {
        // Remove from state
        setData((prev) => prev.filter((item) => item._id !== id));
        Swal.fire("Deleted!", "Item has been deleted successfully.", "success");
      } else {
        Swal.fire("Error!", res?.message || "Failed to delete item.", "error");
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      Swal.fire("Error!", "Something went wrong while deleting.", "error");
    }
  }
};

const Jobsopeningmanagement = () => {
  const [profile, setProfile] = useState({});
  const [openings, setOpenings] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedOpening, setSelectedOpening] = useState(null); // Added state

  // --- Helper: Normalize positions to array of strings ---
  const normalizePositionsValue = (positions) => {
    if (Array.isArray(positions)) {
      return positions
        .map((item) =>
          typeof item === "string" && item.includes(",")
            ? item.split(",").map((p) => p.trim()).filter(Boolean)
            : typeof item === "string"
              ? item.trim()
              : String(item).trim()
        )
        .flat()
        .filter(Boolean);
    }
    if (typeof positions === "string") {
      return positions.split(",").map((p) => p.trim()).filter(Boolean);
    }
    if (positions == null) return [];
    return String(positions).split(",").map((p) => p.trim()).filter(Boolean);
  };

  // Fetch profile
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const data = await api.myprofile();
        if (data) {
          setProfile({
            username: data.username,
            email: data.email,
            contact: data.contact,
            profileImage: data.profileImage
              ? `${process.env.REACT_APP_UPLOAD_PATH}${data.profileImage}`.replace(
                "//uploads",
                "/uploads"
              )
              : "assets/images/profileimg.webp",
          });
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };
    fetchProfileData();
  }, []);
  const handleDelete = async (location) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete opening at "${location}". This action cannot be undone!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await fetchData.deleteOpening("api/deleteOpening", { locationName: location });
        Swal.fire("Deleted!", `Opening at "${location}" has been deleted.`, "success");
        // Refresh openings after delete
        handleSaved();
      } catch (error) {
        console.error("Error deleting opening:", error);
        Swal.fire("Error!", "Failed to delete opening.", "error");
      }
    }
  };
  // Fetch openings from API
  useEffect(() => {
    const fetchOpenings = async () => {
      try {
        const data = await fetchData.get("/api/currentOpening");
        console.log("raw openings data:", data);
        if (data && typeof data === "object") {
          const normalized = Object.fromEntries(
            Object.entries(data).map(([location, positions]) => [
              location,
              normalizePositionsValue(positions),
            ])
          );
          console.log("normalized openings:", normalized);
          setOpenings(normalized);
        } else {
          setOpenings({});
        }
      } catch (error) {
        console.error("Error fetching openings:", error);
        setOpenings({});
      }
    };
    fetchOpenings();
  }, []);

  const handleEdit = (location, positions) => {
    setSelectedOpening({ location, posts: positions });
    setShowEditModal(true);
  };

  const handleSaved = () => {
    // Refresh openings after edit
    const fetchOpenings = async () => {
      try {
        const data = await fetchData.get("/api/currentOpening");
        if (data && typeof data === "object") {
          const normalized = Object.fromEntries(
            Object.entries(data).map(([location, positions]) => [
              location,
              normalizePositionsValue(positions),
            ])
          );
          setOpenings(normalized);
        } else {
          setOpenings({});
        }
      } catch (error) {
        console.error("Error fetching openings:", error);
        setOpenings({});
      }
    };
    fetchOpenings();
  };

  return (
    <div className="bg-white">
      {/* Header */}
      <div className="d-flex justify-content-between p-3 align-items-center">
        <Link to="/" className="">
          <img src="assets/images/kapil-logo.png" alt="site logo" className="light-logo" />
        </Link>
        <Link to="/job-opening-management" className="job-openings-btn">
          Job Openings Management
        </Link>
        <div className="dropdown">
          <button
            className="d-flex justify-content-center align-items-center rounded-circle"
            type="button"
            data-bs-toggle="dropdown"
          >
            {profile?.profileImage ? (
              <img
                src={profile.profileImage}
                alt="image_user"
                className="w-40-px h-40-px object-fit-cover rounded-circle"
              />
            ) : (
              <img
                src="assets/images/user.png"
                alt="image_user"
                className="w-40-px h-40-px object-fit-cover rounded-circle"
              />
            )}
          </button>
          <div className="dropdown-menu to-top dropdown-menu-sm">
            <ul className="to-top-list">
              <li>
                <Link
                  className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                  to="/myprofile"
                >
                  <Icon icon="solar:user-linear" className="icon text-xl" /> My Profile
                </Link>
              </li>
              <li>
                <a
                  className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                  href={null}
                  onClick={api.signOut}
                >
                  <Icon icon="lucide:power" className="icon text-xl" /> Log Out
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card basic-data-table mt-4">
        <div className="card-body">
          <div className="table-responsive scroll-sm">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Current Job Openings</h5>
              <button
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={() => setShowModal(true)}
              >
                <Icon icon="ic:baseline-plus" width="20" height="20" />
                Add Opening
              </button>
            </div>
            <table id="dataTable" className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center">
                        <input
                          className="form-check-input radius-4 border input-form-dark"
                          type="checkbox"
                          name="checkbox"
                          id="selectAll"
                        />
                      </div>
                      S.L
                    </div>
                  </th>
                  <th scope="col" className="cursor-pointer">
                    Location
                  </th>
                  <th scope="col" className="cursor-pointer">
                    Position
                  </th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(openings).length > 0 ? (
                  Object.entries(openings).map(([location, positions], index) => (
                    <tr key={location + index}>
                      <td>{index + 1}</td>
                      <td>{location}</td>
                      <td>
                        <div
                          className="d-flex flex-wrap gap-2"
                          style={{
                            maxWidth: "1300px",
                            maxHeight: "90px",
                            overflowY: "auto",
                          }}
                        >
                          {positions.map((pos, idx) => (
                            <span
                              key={location + "-" + idx}
                              className="badge text-primary-600 px-3 py-3 rounded-2 text-sm fw-medium"
                              style={{
                                backgroundColor: "#eeeeee",
                                width: "max-content",
                              }}
                            >
                              {pos}
                            </span>
                          ))}
                        </div>
                      </td>
                      <td className="text-center">
                        <Link
                          to="#"
                          className="w-32-px h-32-px me-8 bg-warning-light text-warning-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          onClick={() => handleEdit(location, positions)}
                        >
                          <Icon icon="iconamoon:edit-light" />
                        </Link>
                        <Link
                          to="#"
                          onClick={() => handleDelete(location)}
                          className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        >
                          <Icon icon="iconamoon:trash-light" />
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center text-muted">
                      No openings found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <AddOpeningModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSaved={handleSaved}
      />
      <EditOpeningModal
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        onSaved={handleSaved}
        opening={selectedOpening}
      />
    </div>
  );
};

export default Jobsopeningmanagement;